import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import { Link } from "react-router-dom";
import ApiService from "../../../services/ApiService";
import { fixImageOrientation } from "../../../utils/fixImageOrientation";
import { useAppContext } from "../../../context/AppContext";
import Swal from "sweetalert2";
import SectionLoader from "../../../components/SectionLoader";
import BackButton from "../../../components/BackButton";
import { getOrCreateDeviceId } from "../../../utils/deviceId";

const UploadWeightTicket: React.FC = () => {
  const deliveryID = localStorage.getItem("delivery_id");
  const vendor_id = localStorage.getItem("vendor_id");
  const sales_order_id = localStorage.getItem("sales_order_id");
  const api_token = localStorage.getItem("_token");
  const navigate = useNavigate();
  const {
    purchaseOrder,
    delivery,
    photos,
    setPhotos,
    setPurchaseOrder,
    setToken,
    setDelivery,
    setSalesOrder,
    setLoads,
    setAttachments,
    setLoadItems,
    setMeterialSo,
    setMaterialfo,
    setProgressDeliveries,
  } = useAppContext();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Fresh data fetch on load
  useEffect(() => {
    const fetchFreshData = async () => {
      if (!api_token || !sales_order_id) {
        setIsLoading(false);
        return;
      }

      if (delivery && delivery.id && delivery.status) {
        // Validate delivery status - should be 'picked_up' for weight ticket page
        if (delivery.status !== "picked_up" && delivery.status !== "reached") {
          if (delivery.status === "assigned") {
            navigate("/pick-up");
          } else if (delivery.status === "open") {
            navigate("/");
          } else if (delivery.status === "completed") {
            navigate("/");
          }
          setIsLoading(false);
          return;
        }
        setIsLoading(false);
        return;
      }

      if (vendor_id && sales_order_id) {
        try {
          const deviceId = getOrCreateDeviceId();
          const responseData = await ApiService.getFreshData({
            vendor_id: vendor_id,
            sales_order_id: sales_order_id,
            delivery_id: deliveryID || null,
            token: false,
            device_id: deviceId,
          });

          if (responseData && responseData.success) {
            setPurchaseOrder(responseData.data.purchase_order);
            setToken(responseData.api_token);
            setDelivery(responseData.data.delivery);
            setLoads(responseData.data.loads);
            setLoadItems(responseData.data.item_loads);
            setPhotos(responseData.data.photos || []);
            setAttachments(responseData.data.attachments || []);
            setSalesOrder(responseData.data.sales_order);
            setMeterialSo(responseData.data.meterial_so);
            setMaterialfo(responseData.data.material_fo);
            setProgressDeliveries(responseData.data.progress);

            if (responseData.data.delivery) {
              const deliveryStatus = responseData.data.delivery.status;
              if (
                deliveryStatus !== "picked_up" &&
                deliveryStatus !== "reached"
              ) {
                if (deliveryStatus === "assigned") {
                  navigate("/pick-up");
                } else if (deliveryStatus === "open") {
                  navigate("/");
                }
              }
            }
          }
        } catch (error: any) {
          console.error("Error fetching fresh data:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchFreshData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api_token, vendor_id, sales_order_id]);

  const [file, setFile] = useState<string | undefined>(undefined);
  const [isfileUploaded, setIsFileUploaded] = useState<boolean>(false);
  const [getFileForApi, setGetFileForApi] = useState<File | null>(null);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [selectedFilePreviews, setSelectedFilePreviews] = useState<string[]>([]);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const pickedMaterials = (() => {
    const rawMaterials = delivery?.picked_up_material;
    if (Array.isArray(rawMaterials)) {
      return rawMaterials.filter((item) => typeof item === "string" && item.trim() !== "");
    }

    const storedMaterials = localStorage.getItem("picked_up_material");
    if (!storedMaterials) {
      return [];
    }

    try {
      const parsed = JSON.parse(storedMaterials);
      return Array.isArray(parsed)
        ? parsed.filter((item) => typeof item === "string" && item.trim() !== "")
        : [];
    } catch {
      return [];
    }
  })();
  const requiresSplitWeightTickets = pickedMaterials.length > 1;

  useEffect(() => {
    if (!photos || !Array.isArray(photos)) {
      console.log("Photos not available or not an array:", photos);
      return;
    }

    let OldWeightTicket = photos.filter(
      (field: any) =>
        field &&
        field.delivery_id === delivery.id &&
        field.photo_type === "weight_ticket"
    );

    console.log("Photos:", photos);
    console.log("OldWeightTicket:", OldWeightTicket);

    if (OldWeightTicket.length > 0) {
      const weightTicket = OldWeightTicket[0];
      console.log("Weight ticket found:", weightTicket);
      console.log("file_url:", weightTicket.file_url);

      // Check if file_url exists and is a valid string
      if (
        weightTicket.file_url &&
        typeof weightTicket.file_url === "string" &&
        weightTicket.file_url.trim() !== "" &&
        weightTicket.file_url !== "null" &&
        weightTicket.file_url !== "undefined"
      ) {
        console.log("Setting file to:", weightTicket.file_url);
        setFile(weightTicket.file_url);
        setIsFileUploaded(true);
      } else {
        console.log("file_url is invalid or empty:", weightTicket.file_url);
        setIsFileUploaded(false);
        setFile(undefined);
      }
    } else {
      // console.log('No weight ticket found in photos array');
      // setIsFileUploaded(false);
      // setFile(undefined);
    }
  }, [photos, delivery?.id]);

  if (isLoading || !purchaseOrder) return <SectionLoader />;

  async function getWeightTicketFile(event: React.ChangeEvent<HTMLInputElement>) {
    const input = event.currentTarget;
    const uploadedFiles = Array.from(event.target.files ?? []);
    if (uploadedFiles.length > 0) {
      const fixedFiles = await Promise.all(
        uploadedFiles.map((uploadedFile) => fixImageOrientation(uploadedFile))
      );
      const previews = await Promise.all(
        fixedFiles.map(
          (fixedFile) =>
            new Promise<string>((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result as string);
              reader.onerror = () => reject(reader.error);
              reader.readAsDataURL(fixedFile);
            })
        )
      );

      if (requiresSplitWeightTickets) {
        setSelectedFiles((currentFiles) =>
          [...currentFiles, ...fixedFiles].slice(0, pickedMaterials.length)
        );
        setSelectedFilePreviews((currentPreviews) =>
          [...currentPreviews, ...previews].slice(0, pickedMaterials.length)
        );
      } else {
        setSelectedFiles(fixedFiles);
        setSelectedFilePreviews(previews);
      }

      setGetFileForApi(fixedFiles[0]);
      setFile(previews[previews.length - 1]);

      // Mobile cameras return one file per capture. Reset so another capture fires onChange.
      input.value = "";
    }
  }

  function removeSelectedWeightTicket(index: number) {
    const remainingFiles = selectedFiles.filter((_, fileIndex) => fileIndex !== index);
    const remainingPreviews = selectedFilePreviews.filter(
      (_, previewIndex) => previewIndex !== index
    );

    setSelectedFiles(remainingFiles);
    setSelectedFilePreviews(remainingPreviews);
    setGetFileForApi(remainingFiles[0] ?? null);
    setFile(remainingPreviews[remainingPreviews.length - 1]);
  }

  const SubmitFileUploadTicket = async () => {
    setButtonLoading(true);

    // File validation
    const filesToUpload = selectedFiles.length > 0 ? selectedFiles : (getFileForApi ? [getFileForApi] : []);

    if (filesToUpload.length === 0) {
      Swal.fire({
        title: "Error",
        text: "Please upload a weight ticket.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setButtonLoading(false);
      return;
    }

    if (requiresSplitWeightTickets && filesToUpload.length !== pickedMaterials.length) {
      Swal.fire({
        title: "Error",
        text: `Please upload ${pickedMaterials.length} weight tickets, one for each selected material.`,
        icon: "error",
        confirmButtonText: "OK",
      });
      setButtonLoading(false);
      return;
    }

    // Validate file type
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp",
      "image/gif",
    ];
    const invalidFile = filesToUpload.find((file) => !allowedTypes.includes(file.type));
    if (invalidFile) {
      Swal.fire({
        title: "Error",
        text: "Invalid file type. Please upload an image file (JPEG, PNG, WebP, or GIF).",
        icon: "error",
        confirmButtonText: "OK",
      });
      setButtonLoading(false);
      return;
    }

    // Validate file size (max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    const oversizedFile = filesToUpload.find((file) => file.size > maxSize);
    if (oversizedFile) {
      Swal.fire({
        title: "Error",
        text: "File size too large. Please upload a file smaller than 10MB.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setButtonLoading(false);
      return;
    }

    // Use delivery from context or fallback to localStorage
    const currentDeliveryId = delivery?.id || deliveryID;
    if (!currentDeliveryId) {
      Swal.fire({
        title: "Error",
        text: "Delivery ID not found. Please refresh the page.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setButtonLoading(false);
      return;
    }

    const vendor_id = localStorage.getItem("vendor_id");

    let responseData = null;

    try {
      for (let index = 0; index < filesToUpload.length; index++) {
        const formData = new FormData();
        formData.append("delivery_id", currentDeliveryId);
        formData.append("file", filesToUpload[index]);
        formData.append("photo_type", "weight_ticket");
        if (vendor_id) {
          formData.append("vendor_id", vendor_id);
        }
        if (requiresSplitWeightTickets) {
          formData.append("allow_multiple", "1");
        }

        responseData = await ApiService.uploadFile(formData);
      }

      if (responseData && responseData.success) {
        setButtonLoading(false);
        setPhotos(responseData.data);
        Swal.fire({
          title: "Success",
          text: "Weight ticket uploaded successfully.",
          icon: "success",
          confirmButtonText: "Navigate To jobsite",
        }).then(() => {
          localStorage.setItem("page", "jobsite");
          navigate("/jobsite");
        });
      }
    } catch (error: any) {
      console.error("Error uploading weight ticket:", error);
      setButtonLoading(false);
      Swal.fire({
        title: "Error",
        text:
          error instanceof Error ? error.message : "An unknown error occurred.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <Sidebar />

        <div className="col-lg-9 col-12 content-area">
          <div className="row">
            <div className="col-12 mb-3">
              <BackButton />
            </div>
            <div className="col-12">
              <div className="box py-md-5 py-1 px-3">
                <h5 className="mb-0 text-center fw-semibold">
                  Capture a photo of the weight ticket showing the load weight
                  and date, then click Next.
                </h5>
              </div>
            </div>

            <div className="col-md-12 m-auto mt-1">
              <div
                style={file ? { backgroundImage: `url(${file})` } : {}}
                className="image-box"
              >
                <label htmlFor="fileUpload" className="custom-file-upload">
                  Take Photo Or Upload File
                  <i className="bi bi-camera secondary-text m-auto"></i>
                </label>
                <input
                  id="fileUpload"
                  accept="image/*"
                  onChange={getWeightTicketFile}
                  name="weight_ticket"
                  type="file"
                  multiple={requiresSplitWeightTickets}
                />
              </div>
              {requiresSplitWeightTickets && selectedFilePreviews.length > 0 && (
                <div className="d-flex flex-wrap justify-content-center gap-3 mt-3">
                  {selectedFilePreviews.map((preview, index) => (
                    <div
                      key={`${selectedFiles[index]?.name ?? "ticket"}-${index}`}
                      className="position-relative border rounded p-2 bg-white"
                      style={{ width: "140px" }}
                    >
                      <img
                        src={preview}
                        alt={`Weight ticket ${index + 1}`}
                        className="w-100 rounded"
                        style={{ height: "100px", objectFit: "cover" }}
                      />
                      <button
                        type="button"
                        className="btn btn-sm btn-danger position-absolute top-0 end-0"
                        aria-label={`Remove weight ticket ${index + 1}`}
                        onClick={() => removeSelectedWeightTicket(index)}
                      >
                        &times;
                      </button>
                      <div className="small text-center mt-2 text-truncate">
                        {pickedMaterials[index] || `Material ${index + 1}`}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {requiresSplitWeightTickets && (
                <div className="text-center mt-3 small text-muted">
                  Captured {selectedFiles.length} of {pickedMaterials.length} weight tickets.
                </div>
              )}
            </div>
          </div>

          <div className="d-flex row mt-4 m-auto flex-wrap align-items-center justify-content-center gap-3">
            <div className="col-md-6 col-12">
              {file && (
              <button
                onClick={SubmitFileUploadTicket}
                className="btn-orange w-100"
              >
                {buttonLoading && (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
                {isfileUploaded ? "Re-Upload" : "Upload"}
              </button>
              )}
            </div>
            <div className="col-md-6 col-12">
              {!isfileUploaded && (
                <Link
                  to="/jobsite"
                  className="btn-light-orange w-100 text-center d-block"
                >
                  Skip For Now
                </Link>
              )}
              {isfileUploaded && (
                <Link
                  to="/jobsite"
                  className="btn-light-orange w-100 text-center d-block"
                >
                  Next
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UploadWeightTicket;
